import "@/App.css";
import { BrowserRouter, Routes, Route, useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import AboutPage from "@/components/AboutPage";
import SpecialitiesSection from "@/components/SpecialitiesSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseSection from "@/components/WhyChooseSection";
import HospitalMarquee from "@/components/HospitalMarquee";
import SymptomsSection from "@/components/SymptomsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import OvarianCancerPage from "@/components/OvarianCancerPage";
import CervicalCancerPage from "@/components/CervicalCancerPage";
import UterineCancerPage from "@/components/UterineCancerPage";
import VaginalVulvalCancerPage from "@/components/vaginal-vulval-cancer-carePage";
import LaparoscopicRoboticSurgeryPage from "@/components/LaparoscopicRoboticSurgeryPage";
import HipecSurgeryPage from "@/components/HipecSurgeryPage";
import CancerScreeningPage from "@/components/CancerScreeningPage";
import RoboticSurgeryPage from "@/components/RoboticSurgeryPage";
import NonCancerPage from "@/components/NonCancerPage";
import BookAppointmentPage from "@/components/BookAppointmentPage";
import SpecialitiesPage from "@/components/SpecialitiesPage";
import ContactPage from "@/components/ContactPage";
import HospitalsPage from "@/components/HospitalsPage";
import TestimonialsPage from "@/components/TestimonialsPage";
import FaqPage from "@/components/FaqPage";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>
          Best Gynecologic Oncologist in Kolkata | Dr Neha Agarwal Cancer Specialist
        </title>
        <meta
          name="description"
          content="Consult Dr Neha Agarwal, leading gynecologic oncologist in Kolkata for ovarian, cervical & uterine cancer treatment. Book appointment today."
        />

        <meta
          name="keywords"
          content="gynecologic oncologist in Kolkata, ovarian cancer doctor Kolkata, cervical cancer specialist Kolkata"
        />
      </Helmet>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        {/* <ServicesSection /> */}
        <SpecialitiesSection />
        <WhyChooseSection />
        <HospitalMarquee />
        <SymptomsSection />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTA />
      </main>
      {/* <Footer /> */}
    </>
  );
};

const serviceNames = {
  "ovarian-cancer-treatment": "Ovarian Cancer Treatment",
  "cervical-cancer-treatment": "Cervical Cancer Treatment",
  "uterine-cancer-treatment": "Uterine (Endometrial) Cancer Treatment",
  "vaginal-vulval-cancer-care": "Vaginal & Vulval Cancer Care",
  "hipec-surgery": "HIPEC Surgery",
  "laparoscopic-robotic-surgery": "Laparoscopic & Robotic Surgery",
  "cancer-screening": "Cancer Screening & Preventive Oncology",
  "robotics-surgery": "Robotics Surgery",
  "non-cancer": "Non Cancer"
};

const ServicePage = () => {
  const { slug } = useParams();
  const name = serviceNames[slug] || "Service";

  return (
    <div className="min-h-screen bg-[#F9F9F6] flex items-center justify-center">
      <div className="text-center px-6 max-w-lg">
        <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-4">Service</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1E3F33] mb-4">
          {name}
        </h1>
        <p className="text-[#4A6359] text-lg mb-8">
          Detailed information about this service will be available soon. Please contact us for more details.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[#1E3F33] text-[#F9F9F6] px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-[#2C5545] transition-colors duration-200"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
      </div>
    </div>
  );
};

const BookAppointment = () => {
  return (
    <div className="min-h-screen bg-[#F9F9F6] flex items-center justify-center">
      <div className="text-center px-6">
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1E3F33] mb-4">
          Book Appointment
        </h1>
        <p className="text-[#4A6359] text-lg mb-8">
          This page will be available soon. Please contact us via WhatsApp or phone for appointments.
        </p>
        <a
          href="/"
          className="inline-flex items-center gap-2 bg-[#1E3F33] text-[#F9F9F6] px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-[#2C5545] transition-colors duration-200"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        <Routes>

          {/* ================= NORMAL PAGES WITH FOOTER ================= */}

          <Route
            path="/"
            element={
              <>
                <Header />
                <HomePage />
                <Footer />
              </>
            }
          />

          <Route
            path="/book-appointment"
            element={
              <>
                <Header />
                <BookAppointmentPage />
                <Footer />
              </>
            }
          />

          <Route
            path="/about"
            element={
              <>
                <Header />
                <AboutPage />
                <Footer />
              </>
            }
          />

          <Route
            path="/contactpage"
            element={
              <>
                <Header />
                <ContactPage />
                <Footer />
              </>
            }
          />

          <Route
            path="/specialities"
            element={
              <>
                <Header />
                <SpecialitiesPage />
                <Footer />
              </>
            }
          />

          <Route
            path="/hospitals"
            element={
              <>
                <Header />
                <HospitalsPage />
                <Footer />
              </>
            }
          />

          <Route
            path="/testimonials"
            element={
              <>
                <Header />
                <TestimonialsPage />
                <Footer />
              </>
            }
          />

          <Route
            path="/faq"
            element={
              <>
                <Header />
                <FaqPage />
                <Footer />
              </>
            }
          />

          {/* ================= SERVICE PAGES WITHOUT GLOBAL FOOTER ================= */}

          <Route
            path="/services/ovarian-cancer-treatment"
            element={
              <>
                <Header />
                <OvarianCancerPage />
              </>
            }
          />

          <Route
            path="/services/cervical-cancer-treatment"
            element={
              <>
                <Header />
                <CervicalCancerPage />
              </>
            }
          />

          <Route
            path="/services/uterine-cancer-treatment"
            element={
              <>
                <Header />
                <UterineCancerPage />
              </>
            }
          />

          <Route
            path="/services/vaginal-vulval-cancer-care"
            element={
              <>
                <Header />
                <VaginalVulvalCancerPage />
              </>
            }
          />

          <Route
            path="/services/laparoscopic-robotic-surgery"
            element={
              <>
                <Header />
                <LaparoscopicRoboticSurgeryPage />
              </>
            }
          />

          <Route
            path="/services/hipec-surgery"
            element={
              <>
                <Header />
                <HipecSurgeryPage />
              </>
            }
          />

          <Route
            path="/services/cancer-screening"
            element={
              <>
                <Header />
                <CancerScreeningPage />
              </>
            }
          />

          <Route
            path="/services/robotics-surgery"
            element={
              <>
                <Header />
                <RoboticSurgeryPage />
              </>
            }
          />

          <Route
            path="/services/non-cancer"
            element={
              <>
                <Header />
                <NonCancerPage />
              </>
            }
          />

          <Route
            path="/services/:slug"
            element={
              <>
                <Header />
                <ServicePage />
              </>
            }
          />

        </Routes>

      </BrowserRouter>
    </div>
  );
}



export default App;
